import { Component, Input } from '@angular/core';
import { Book } from '../book';
import { FormBuilder, FormControl } from '@angular/forms';
import { BooksService } from '../books.service';
import { bookValidator } from '../new-book/book-validation.directive';
import { AuthorsService } from 'src/app/author-group/authors.service';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-selected-book',
  templateUrl: './selected-book.component.html',
  styleUrls: ['./selected-book.component.css']
})
export class SelectedBookComponent {
  @Input() selectedBook?: Book

  constructor(private formBuilder: FormBuilder, private bookService: BooksService, private authorService: AuthorsService) { }

  ngOnChanges() {
    this.resetForm()
  }

  editingBook = false

  //FIXME: - upload file
  newFile: File | undefined = undefined
  newFileName: string | undefined

  authors = [...this.authorService.lastAuthorBatch!!.map(function (author) { return `${author.lastName}, ${author.firstName}` })]
 
  searchAuthors: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(10),
      distinctUntilChanged(),
      map((term) =>
        this.authors.filter((v) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  bookForm = this.formBuilder.group({
    title: [''],
    summary: [''],
    author: [''],
    purchaseLink: [''],
  }, { validators: bookValidator })

  titleControl = <FormControl>this.bookForm.get('title');
  summaryControl = <FormControl>this.bookForm.get('summary');
  authorControl = <FormControl>this.bookForm.get('author');


  editBook() {
    this.editingBook = true
    this.bookService.keepFocus = true
  }

  removeBook() {
    this.bookService.deleteBook(this.selectedBook!!)
  }

  cancelUserEditing() {
    this.resetForm()
    this.editingBook = false
    this.bookService.keepFocus = false
  }

  resetForm() {
    this.titleControl.setValue(this.selectedBook!!.title)
    this.summaryControl.setValue(this.selectedBook!!.summary)
    this.authorControl.setValue(this.selectedBook!!.author)
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.newFile = file
        this.newFileName = file.name
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.newFile = undefined
    this.newFileName = undefined
  }

  cancelClicked() {
    this.bookService.addBookCancelled()
    this.editingBook = false
  }

  submitBookEdits() {
    const editedBook = this.createBookFromForm()
    if (JSON.stringify(editedBook) === JSON.stringify(this.selectedBook) && this.newFile == undefined) {
      this.cancelUserEditing()
      alert("No changes made")
      return
    }
    this.bookService.updateBook(editedBook, this.newFile)
  }

  createBookFromForm(): Book {
    const uid = this.selectedBook?.uid!!
    const title = this.bookForm.value.title!!
    const summary = this.bookForm.value.summary!!
    const author = this.bookForm.value.author!!
    const purchaseLink = this.bookForm.value.purchaseLink
    return ({uid: uid, title: title, summary: summary, author: author, purchaseLink: purchaseLink}) as Book
  }
}
